/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetOrCreateChatRequest, TGetOrCreateChatModel, IMappers, TGetOrCreateChatResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV1GetOrCreateChatResponse } from '../../entities/get_or_create_chat/V1GetOrCreateChatResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetOrCreateChatModel(parameters: TGetOrCreateChatRequest): TGetOrCreateChatModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-consultants',
    pathApi: '/v1/get-or-create-chat/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetOrCreateChatOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetOrCreateChatRequest;
}

export async function fetchGetOrCreateChat<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetOrCreateChatOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetOrCreateChatResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetOrCreateChatModel(parameters),
    config,
  )) as FetchResponse<TGetOrCreateChatResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1GetOrCreateChatResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetOrCreateChatResponse>;
}
